module.exports = __webpack_public_path__ + "static/media/haiti.cfa7a8e1.jpg";